import React, { useState } from 'react';
import Education from './Education';
import Experience from './Experience';
import Collaboration from './Collaboration';

const ProfBackground = ({ userProps, isCurrentUser, setUserData }) => (
  <>
    <Education userProps={userProps} isCurrentUser={isCurrentUser} setUserData={setUserData} />
    <Experience userProps={userProps} isCurrentUser={isCurrentUser} setUserData={setUserData} />
    <Collaboration userProps={userProps} isCurrentUser={isCurrentUser} setUserData={setUserData} />
  </>
);

export default ProfBackground;
